import React from 'react'

function TenderTextLGZAMSB() {
  return (
    <embed src="\pdfs\DAT2.5.1.3_LG-ZA-M-SB_Dezentrales_Lueftungsgeraet_kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextLGZAMSB